import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { darkGrayFontColor, inputBorderColor } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	popup: {
		width: 420,
	},
	body: {
		maxHeight: 420,
		overflowY: 'auto',
		paddingRight: 4,
	},
	sectionLabel: {
		margin: '0 0 8px',
		fontSize: 13,
		fontWeight: 600,
		color: THEME.colors.text.light,
	},
	groupsSection: {
		marginTop: 10,
	},
	centered: {
		display: 'flex',
		justifyContent: 'center',
		padding: '24px 0',
	},
	emptyText: {
		margin: 0,
		fontSize: 14,
		color: THEME.colors.text.light,
	},
	list: {
		listStyle: 'none',
		margin: 0,
		padding: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
	},
	row: {
		display: 'flex',
		alignItems: 'center',
		gap: 10,
		padding: '8px 10px',
		borderRadius: 6,
		':hover': {
			backgroundColor: `${inputBorderColor}50`,
		},
	},
	label: {
		fontSize: 14,
		color: darkGrayFontColor,
		cursor: 'pointer',
		flex: 1,
	},
});
